import { useContext } from 'react';
import {
  AssetViewerStateContext,
  IAssetViewerStateContextValue
} from '@context/AssetViewerStateContext';

export function useAssetViewerState(): IAssetViewerStateContextValue {
  const ctx = useContext(AssetViewerStateContext);
  if (!ctx) {
    throw new Error(
      'useAssetViewerState must be used within AssetViewerStateProvider'
    );
  }
  return ctx;
}
